import Vue from 'vue'
import ElementUI, { Dialog } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import { isReadOnlyAdmin } from './utils/permission'

Vue.prototype.$isReadOnlyAdmin = function $isReadOnlyAdmin() {
  return isReadOnlyAdmin(store.state.user)
}
import VueRouter from 'vue-router'

// 忽略重复导航 / 导航被取消（多接口 401 或连续跳转时常见）
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err && (err.name === 'NavigationDuplicated' || /Navigation cancelled/i.test(err.message))) {
      return err
    }
    return Promise.reject(err)
  })
}
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err && (err.name === 'NavigationDuplicated' || /Navigation cancelled/i.test(err.message))) {
      return err
    }
    return Promise.reject(err)
  })
}

// 弹窗仅允许点右上角 X 或按钮关闭，避免误点遮罩层关闭（尤其嵌套弹窗）
Dialog.props.closeOnClickModal.default = false

function cleanupStaleOverlays() {
  if (typeof document === 'undefined') return
  const wrappers = Array.from(document.querySelectorAll('body > .el-dialog__wrapper'))
  const visible = wrappers.filter(el => el.style.display !== 'none')
  const modals = Array.from(document.querySelectorAll('body > .v-modal'))
  if (modals.length > visible.length) {
    modals.slice(visible.length).forEach(el => el.remove())
  }
  if (!visible.length) {
    document.body.classList.remove('el-popup-parent--hidden')
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }
}

router.afterEach(() => {
  cleanupStaleOverlays()
})

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
